import { render, staticRenderFns } from "./customize-options.vue?vue&type=template&id=5d0229fc&scoped=true&"
import script from "./customize-options.vue?vue&type=script&lang=js&"
export * from "./customize-options.vue?vue&type=script&lang=js&"
import style0 from "./customize-options.vue?vue&type=style&index=0&id=5d0229fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0229fc",
  null
  
)

export default component.exports